// extracted by mini-css-extract-plugin
export var acSubtitle = "style-mod--ac-subtitle--11449";
export var acTitle = "style-mod--ac-title--25500";
export var articleCard = "style-mod--article-card--57fc3";
export var articleCardBody = "style-mod--article-card-body--e9ff4";
export var articleCardContent = "style-mod--article-card-content--31bae";
export var articleCardLink = "style-mod--article-card-link--81693";
export var articleCardTitle = "style-mod--article-card-title--fd22e";
export var articleContent = "style-mod--article-content--9cce5";
export var articleContentFirst = "style-mod--article-content-first--8bde6";
export var articleImg = "style-mod--article-img--328dd";
export var articleSlider = "style-mod--article-slider--bb17a";
export var hiddenMobile = "style-mod--hidden-mobile--5ea44";
export var topArticles = "style-mod--top-articles--e5b8a";